import { ICycle, IExtendedUser, SubmissionStatus } from "src/common/types";
import { IInstructionsMap } from "src/common/contexts/Instructions/intructionsProvider";
import { IElement, IElementPayload } from "./questions";

export interface IQuestionnairePayload {
  id: string;
  meta: IQuestionnaireMeta | null;
  questionnaireType: QuestionnaireType;
  submissionStatus: SubmissionStatus;
  submissionDate: Date | string | null;
  submissionDueDate: Date | string;
  additionalComments: string | null;
  template: {
    id: string;
    instructions: string;
    elements: IElementPayload[];
    instructionsMap: IInstructionsMap;
  };
  talk: {
    id: string;
    participant: IExtendedUser;
    finalRating: number | null;
    scheduledDate: Date | string | null;
    status: string;
    cycle: ICycle;
  };
}

export interface IQuestionnaireMeta {
  readBySupervisor: boolean;
}

export interface IQuestionnaire {
  cycle: ICycle;
  feedbackTaker: IExtendedUser;
  submissionStatus: SubmissionStatus;
  submissionDate: Date | null;
  submissionDueDate: Date;
  talkScheduledDate: Date | null;
  talkStatus: string;
  additionalComments: string | null;
  elements: IElement[];
  instructions: string;
  instructionsMap: IInstructionsMap;

  questionnaireType: QuestionnaireType;
}

export enum QuestionnaireType {
  SelfAssessment = "SELF",
  DirectSupervisor = "DIRECT_SUPERVISOR",
  Peer = "PEER",
  PeerSummary = "PEER_SUMMARY",
  AnonymousDSV = "ANONYMOUS_DSV",
  AnonymousDSVSummary = "ANONYMOUS_DSV_SUMMARY"
}

export const questionnaireTypes = {
  [QuestionnaireType.SelfAssessment]: "selfAssessment",
  [QuestionnaireType.DirectSupervisor]: "directSupervisor",
  [QuestionnaireType.Peer]: "peer",
  [QuestionnaireType.PeerSummary]: "peerSummary",
  [QuestionnaireType.AnonymousDSV]: "anonymousDSV",
  [QuestionnaireType.AnonymousDSVSummary]: "anonymousDSVSummary"
};

export interface IQuestionnaireTemplate {
  config: string;
  id: string;
  name: string;
  type: QuestionnaireType;
}

export interface IQuestionnaireTemplatePayload {
  entities: IQuestionnaireTemplate[];
}
